import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface UpdateInvestmentPayload {
  uuid: string;
  name?: string;
  primaryValue?: number;
  currencyUuid?: string | null;
  additionalInfo?: string | null;
  relianceCanView?: boolean;
  status?: string;
  details?: Record<string, unknown>;
}

export const useUpdateInvestment = (
  options?: UseMutationOptions<any, Error, UpdateInvestmentPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateInvestment"],
    mutationFn: async ({ uuid, ...data }: UpdateInvestmentPayload) => {
      return axiosInstance
        .patch(`/investments/${uuid}`, data)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa zapisywanie zmian...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "update-investment",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      queryClient.invalidateQueries({ queryKey: ["investmentTransactions", variables.uuid] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      const status = (error as any).status;
      if (status === 404) {
        Toast({
          message: "Inwestycja nie została znaleziona lub została usunięta.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "update-investment",
        });
        queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      } else {
        Toast({
          message: "Błąd podczas aktualizacji aktywa.",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "update-investment",
        });
      }
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
